import getBasePath from '../functions/api-resource';

let dicionario = {};
const basePath = getBasePath('api', 'dicionario');

const setDicionario = (el) => {
  dicionario[el.label] = el.depara;
};


export default {
  mapa() {
    return localStorage.dicionario ? JSON.parse(localStorage.dicionario) : {};
  },
  carrega(cb) {
    const ultimaData = localStorage.dicionarioData ?
      new Date(localStorage.dicionarioData) :
      new Date();
    if (!localStorage.dicionarioData || Math.abs(ultimaData - new Date()) > 60000) {
      const xhttp = new XMLHttpRequest();
      xhttp.open('GET', `${basePath}`, true);
      xhttp.setRequestHeader('Authorization', `Bearer ${sessionStorage.token}`);
      xhttp.send();
      xhttp.onreadystatechange = function() { // eslint-disable-line
        if (this.readyState === 4) {
          if (this.status === 200) {
            const response = JSON.parse(xhttp.response);
            response.forEach(setDicionario);
            localStorage.setItem('dicionario', JSON.stringify(dicionario));
            localStorage.setItem('dicionarioData', new Date());
          }
          cb();
        }
      };
    } else {
      dicionario = localStorage.dicionario ? JSON.parse(localStorage.dicionario) : {};
      cb();
    }
  },
};



// WEBPACK FOOTER //
// ./src/common/functions/dicionario.js